import { LocalizationServices } from '@/services/LocalizationServices';
import { ModalServices } from '@/services/ModalServices';
import store from '@/store';
import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/escursioni',
            name: 'village_escursioni',
            component: () => import("./views/escursioni.vue"),
            meta: {
                hasBar: true,
                appContainerClass: 'fullPage',
                // showMembership: true,
            },
        },
        {
            path: '/village/escursioni/:identifier',
            name: 'village_escursioni_detail',
            component: () => import("./views/escursioniDetail.vue"),
            meta: {
                hideTopCut: true,
            },
        },
    ];
};